import React from "react";
import CardSwiperSlider from "../CardSwiperSlider";
import CardSwiperSliderMobile from "../CardSwiperSliderMobile";
import { Container } from "./ui";

const desktopCards = [1, 2, 3, 4, 5, 6].map((n) => `https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card${n}.svg`);
const mobileCards = [1, 2, 3, 4, 5, 6, 8, 9, 10].map((n) => `https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard${n}.svg`);

const TrustedIndustries = () => (
  <section className=" py-[64px] lg:py-[80px]">
    <Container>
      <h2 className="text-center text-[28px] font-extrabold tracking-tight text-ink sm:text-[38px]">
        Trusted Website Development Company in India
      </h2>
      <p className="mx-auto mt-[16px] max-w-4xl text-center text-[15px] leading-relaxed text-slate-500 sm:text-[16px]">
        At Datametricks, we are committed to providing professional website development services across a wide range of
        industries, including retail, real estate, finance, education, healthcare, and more. As a leading web development
        company in India, we collaborate with offshore partners to deliver exceptional web design, application development,
        and eCommerce solutions.
      </p>
    </Container>
    <div className="hidden md:block">
      <CardSwiperSlider imagesData={desktopCards} />
    </div>
    <div className="md:hidden">
      <CardSwiperSliderMobile mobileimageData={mobileCards} />
    </div>
  </section>
);

export default TrustedIndustries;
